import { SingleRadioItemModel } from '@ui-components';

export const availableAlertDistanceConst: SingleRadioItemModel<number>[] = [
  {
    name: 'Najbliżej (2 km)',
    value: 2000
  },
  {
    name: 'W pobliżu (5 km)',
    value: 5000
  },
  {
    name: 'Okolice (25 km)',
    value: 25000,
    description: 'domyślne'
  },
  {
    name: 'Daleko (50 km)',
    value: 50000
  }
];
